import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { api, imgUrl } from "../lib/api";
import { SEO } from "../components/SEO";
import { SafeImg } from "../components/site/SafeImg";

export default function PricingPage() {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.plans)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 md:py-16" data-testid="pricing-page">
      <SEO title="Subscription Plans" path="/pricing" description="Compare magazine subscription plans - monthly, half-yearly and annual plans with print and digital access." />
      <div className="max-w-2xl">
        <span className="eyebrow">Subscribe & Save</span>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-3 text-bm-ink">Subscription Plans</h1>
        <p className="text-bm-body mt-4 leading-relaxed">Every plan includes the print edition at your doorstep and the digital flip edition online. Cancel anytime.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
        {plans.map((p) => {
          const mag = p.magazines?.[0];
          const save = p.original_price > p.price ? Math.round((1 - p.price / p.original_price) * 100) : 0;
          return (
            <div key={p.id} className="bm-card p-8 flex flex-col transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-card-hover" data-testid={`plan-card-${p.id}`}>
              <div className="flex items-center gap-4">
                {mag && <SafeImg src={imgUrl(mag.cover_image)} alt={mag.title} className="w-14 aspect-[3/4] object-cover rounded-md shadow-cover" loading="lazy" />}
                <div>
                  <h3 className="font-display font-semibold text-xl leading-snug text-bm-ink">{p.name}</h3>
                  <p className="text-xs text-bm-muted uppercase tracking-[0.1em] font-semibold mt-1">{p.duration_value} {p.duration_unit}</p>
                </div>
              </div>
              <div className="mt-6 flex items-baseline gap-2 flex-wrap">
                <span className="font-display text-3xl font-bold text-bm-ink">₹{p.price.toLocaleString("en-IN")}</span>
                {save > 0 && <span className="text-sm text-bm-muted line-through">₹{p.original_price.toLocaleString("en-IN")}</span>}
                {save > 0 && <span className="chip">Save {save}%</span>}
              </div>
              <ul className="mt-6 space-y-2.5 text-sm text-bm-body flex-1">
                {["Print edition, pan-India delivery", "Digital flip-reader access", "New issues on publish day", "Easy cancellation"].map((f) => (
                  <li key={f} className="flex gap-2"><Check className="w-4 h-4 text-bm-terra shrink-0 mt-0.5" /> {f}</li>
                ))}
              </ul>
              <Link to={`/checkout/${p.id}`} data-testid={`plan-subscribe-${p.id}`} className="btn-primary w-full mt-8">
                Subscribe <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
